import ApiResourceManager from '../ApiResourceManager';
import { TeamReportFormat } from '../../exports/Constants';

export default class TeamReportsManager extends ApiResourceManager {
  create = (data) =>
    this.request({
      method: 'POST',
      url: '/team-reports',
      responseType: data?.format === TeamReportFormat.JSON ? 'json' : 'blob',
      data,
    });

  loadManagerDetails = (data) =>
    this.request({
      method: 'POST',
      url: '/team-reports/manager-details',
      responseType: data?.format === TeamReportFormat.JSON ? 'json' : 'blob',
      data,
    });
}
